'use strict';

var pReduce = require('p-reduce');

module.exports = function (iterable, iterator) {
  return pReduce(iterable, function (a, b, i) {
    return iterator(b, i);
  }).then(function () {
    return iterable;
  });
};